/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_Plans_InitialInputs */

const es_admin_company_overview_plans_initial = /** @type {(inputs: Admin_Company_Overview_Plans_InitialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicial`)
};

const en_admin_company_overview_plans_initial = /** @type {(inputs: Admin_Company_Overview_Plans_InitialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initial`)
};

/**
* | output |
* | --- |
* | "Initial" |
*
* @param {Admin_Company_Overview_Plans_InitialInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_plans_initial = /** @type {((inputs?: Admin_Company_Overview_Plans_InitialInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_Plans_InitialInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_plans_initial(inputs)
	return en_admin_company_overview_plans_initial(inputs)
});
export { admin_company_overview_plans_initial as "admin.company_overview.plans.initial" }